<div class="box skeleton">
    <div class="bone user-email"></div>
    <div class="bone user-email"></div>
    <div class="bone user-email"></div>
</div>